import { Switch, Route } from 'react-router-dom';

import { Home } from 'pages';
import { Agate } from 'pages';

function App() {
  return (
    <Switch>
      <Route exact path='/' component={Home} />
      <Route exact path='/agate/kda/:Lang' component={Agate} />
    </Switch>
  );
}

export default App;
